import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SiteSettingsContext = createContext(null);

const FALLBACK = {
    hero_h1_part1: "Global Media Buying",
    hero_h1_part2: "Stable Infrastructure",
    hero_h1_part3: "Clear Operations",
    hero_subtitle:
        "Managed advertising operations for Meta, Google, TikTok and Snapchat with flexible billing options for scaling teams.",
    hero_fee_badge: "No subscription · Fee from 4%, down to 2% with volume · up to 2% cashback above $1M",
    stats_ad_spend: "$50M+",
    stats_accounts: "1,500+",
    stats_bans: "99.2%",
    stats_provisioning: "< 5m",
    trustpilot_rating: 4.9,
    trustpilot_count: 320,
    contact_telegram: "https://t.me/adrise",
    contact_whatsapp: "https://wa.me/0",
    contact_email: "support@adrise-agency.com",
    contact_phone: "",
    company_name: "Adrise",
    company_legal_name: "Adrise Media Operations",
    company_address: "",
    service_scope: "Managed advertising operations · Media buying support · Billing & account management",
    guarantee_note: "Platform approvals and account status are subject to platform policies.",
    pricing_transparency_note: "Fee starts at 4% and scales down based on volume.",
    meta_page_invite_url: "https://www.facebook.com/AdriseAgency",
    meta_page_invite_handle: "AdriseAgency",
    meta_page_invite_email: "",
    meta_pixel_id: "",
    google_site_verification: "",
    ga4_measurement_id: "",
    ga4_api_secret: "",
    ga4_mp_endpoint: "https://www.google-analytics.com/mp/collect",
    google_ads_conversion_id: "",
    google_ads_qualified_lead_label: "",
    google_ads_begin_checkout_label: "",
    google_ads_purchase_label: "",
    google_ads_application_approved_label: "",
    google_ads_whatsapp_label: "",
    google_ads_telegram_label: "",
    google_ads_complete_registration_label: "",
    topup_fee_percent: 3,
    min_topup_meta_standard: 250,
    min_topup_meta_flex: 500,
    min_topup_google: 250,
    min_topup_tiktok: 250,
    min_topup_snapchat: 250,
    min_topup_bing: 250,
    min_topup_taboola: 250,
    min_topup_outbrain: 250,
};

export function SiteSettingsProvider({ children }) {
    const [settings, setSettings] = useState(FALLBACK);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/site-settings");
            if (data?.settings) {
                setSettings({ ...FALLBACK, ...data.settings });
            }
        } catch {
            // graceful fallback
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <SiteSettingsContext.Provider value={{ settings, loading, refresh }}>
            {children}
        </SiteSettingsContext.Provider>
    );
}

export function useSiteSettings() {
    const ctx = useContext(SiteSettingsContext);
    if (!ctx) return { settings: FALLBACK, loading: false, refresh: () => {} };
    return ctx;
}
